<template>
  <el-dialog
    title="Perguntas do Formulário"
    :visible.sync="visibility"
    :before-close="fechar"
    :modal-append-to-body="false"
    width="35%"
  >
    <el-form size="small" :model="formulario" label-position="top" ref="perguntasForm">
      <el-form-item
        v-for="(pergunta, index) in formulario.perguntasFormulario"
        :label="pergunta.texto"
        :key="pergunta.id"
        :prop="'perguntasFormulario.' + index + '.resposta'"
      >
        <el-input v-model="pergunta.resposta"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gerarFormulario()" type="primary">Gerar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    visibility: Boolean,
    formulario: Object,
    venda: Object
  },
  data() {
    return {
      nome: ""
    };
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"]),
    ...mapActions("vendasStore", [
      "gerarFormularioVenda"
    ]),
    gerarFormulario() {
      this.showLoading();


      if (this.venda !== undefined && this.venda.id != 0) {
        this.formulario.venda = this.venda;

        this.gerarFormularioVenda(this.formulario)
          .then(resultado => {
            window.open(resultado.data, "_blank");
            this.hideLoading();
            this.fechar();
          })
          .catch(() => {
            this.$message.error("Ocorreu um erro.");
            this.hideLoading();
          });
      }
    },

    fechar() {
      this.$emit("close");
    }
  }
};
</script>

